import styled from 'styled-components';
import {
  SectionParent,
  BlueButtonA,
  H1,
} from '../../../components/StyledComponents';

import React from 'react';
import Hero from '../../../assets/v2/png/career_top.png';
import HeroMobile from '../../../assets/v2/group-168.svg';
import CareerBottom from '../../../assets/v2/png/career_banner.jpg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { navigate } from 'gatsby';
import { Title } from '../HomePage/HomepageSectionOne';

const ImgItem = styled(LazyLoadImage)`
  width: 125%;
  margin-left: -10%;
  margin-top: 3.5rem;
  visibility: hidden;
  @media (min-width: 800px) and (max-width: 1100px) {
    height: 80%;
  }
  @media (max-width: 1100px) {
    height: 80%;
    width: 125%;
  }
  @media (max-width: 768px) {
    margin-top: 0rem;
    width: calc(90%);
    margin-left: 0rem;
    visibility: visible;
  }
`;

const BlueButtonNew = styled(BlueButtonA)`
  margin-left: 3.5rem;
  @media (max-width: 520px) {
    margin-left: 1rem;
  }
`;
const SectionOne = styled(SectionParent)`
  padding-top: 8rem !important;
  padding-bottom: 5rem;
  min-height: 40vw;
  background-position: bottom;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1440px) and (min-width: 980px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1300px) and (min-width: 980px) {
    padding-top: 5rem !important;
  }
  @media (max-width: 980px) and (min-width: 768px) {
    padding-top: 4rem !important;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 8rem !important;
  }
  width: 100%;
  display: grid;
`;

const MagicContainer = styled.div`
  position: absolute;
  top: -999px;
  left: -999px; /* start out of view */
  border-radius: 50%;
  width: 350px;
  height: 350px;
  box-sizing: border-box;
  .inside {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    border: 1px solid #4251a3;
    background: url(${CareerBottom}) 50% 50% no-repeat fixed;
    background-position-y: 5rem;
    @media (min-width: 768px) {
      display: unset;
      background-size: contain;
    }
    @media (max-width: 768px) {
      display: none;
      background-size: contain;
    }
  }
  .clear {
    margin: 10px;
    height: 340px;
    width: 340px;
  }
`;
const MagicContainerFixed = styled.div`
  min-height: 40vw;
  position: absolute;
  width: 100%;
  display: none;
  @media (min-width: 768px) {
    display: block;
    background: url(${Hero}) 50% 50% no-repeat fixed;
    background-position-y: 5rem;
    background-size: contain;
  }
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(12, 1fr);
  /* padding-left: 5rem; */
  position: fixed;
  grid-gap: 5rem;
  display: grid;
  @media (max-width: 768px) {
    padding-left: 0rem;
    position: static;
    grid-gap: 0rem;
  }
`;

const SectionOneTitle = styled(Title)`
  max-width: 450px;
  line-height: 1.15;
  color: #4150a3;
  margin-left: 3rem;
  @media (max-width: 1280px) {
    font-size: 36px;
  }
  @media (max-width: 1024px) {
    font-size: 32px;
  }
  @media (max-width: 768px) {
    text-align: center;
    justify-self: center;
    font-size: 32px;
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    padding: 0 3rem;
    margin-left: 0;
  }
  @media (max-width: 375px) {
    padding: 0;
  }
`;

const GridRight = styled.div`
  grid-column: span 8;
  z-index: 10;
  padding-right: 3rem;
  padding-left: 20vw;
  margin-top: 1rem;
  align-content: center;
  display: grid;
  @media (max-width: 1920px) {
    padding-left: 14rem;
  }
  @media (max-width: 1680px) {
    padding-left: 12rem;
    margin-top: -3rem;
  }
  @media (max-width: 1300px) {
    padding-left: 5rem;
    padding-right: 0rem;
  }
  @media (max-width: 1100px) {
    padding-right: 0rem;
  }
  @media (max-width: 980px) {
    margin-top: 0rem;
    padding-left: 0rem;
    padding-right: 0rem;
  }
  @media (max-width: 768px) {
    grid-column: span 12;
    padding-right: 0rem;
    margin-top: 0rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
`;
const GridLeft = styled.div`
  grid-column: span 4;
  @media (max-width: 1100px) {
    padding-left: 0;
  }
  @media (max-width: 768px) {
    grid-column: span 12;
    padding-left: 0;
    justify-self: center;
    max-width: 80%;
  }
  @media (max-width: 520px) {
    width: 80%;
  }
`;

const BlueButtonWrapper = styled.div`
  margin-left: -10px;
  margin-top: 24px;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

const ContainerDiv = styled.div`
  @media (min-width: 768px) {
    z-index: 0;
    min-height: 40vw;
    position: relative;
    overflow: hidden;
  }
`;

export default class TestSectionOne extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      left: 10,
      top: 10,
      now: Date.now(),
      points: [
        {
          top: 1000,
          left: 100,
          time: Date.now(),
        },
      ],
    };
  }
  needRAF: boolean = true;
  sectionRef: any;

  componentDidMount() {
    setInterval(() => {
      this.setState((state: any) => ({
        points: state.points.filter((point: any) => {
          const age = Date.now() - point.time;
          return age < 2000;
        }),
      }));
    }, 500);
  }
  handleMouseMove = (event: any) => {
    const x = event.pageX;
    const y = event.pageY;
    // store the new timestamp + mouse position in state, which will trigger re-render
    if (this.needRAF) {
      this.needRAF = false;
      requestAnimationFrame(() => this.req(x, y));
    }
  };

  req = (x: any, y: any) => {
    this.setState(
      (state: any) => ({
        points: [{ left: x - 180, top: y - 250, time: Date.now() }],
      }),
      () => {
        this.needRAF = true;
      }
    );
  };

  render() {
    return (
      <div style={{ paddingTop: '5rem' }}>
        <ContainerDiv
          ref={(ref: HTMLElement) => (this.sectionRef = ref)}
          onMouseMove={this.handleMouseMove}
        >
          <MagicContainerFixed />
          {this.state.points.map((item: any) => (
            <MagicContainer
              key={`${item.top}-${item.left}`}
              style={{
                top: item.top,
                left: item.left,
              }}
            >
              <div className="inside clear background-cover" />
            </MagicContainer>
          ))}
          <SectionOne>
            <SectionItemContainer>
              <GridLeft>
                <ImgItem alt="Your App, Your Devices" src={HeroMobile} />
              </GridLeft>
              <GridRight>
                <SectionOneTitle>
                  Let’s build a fantastic team, have fun, and change the world
                  together!
                </SectionOneTitle>
                <BlueButtonWrapper>
                  <BlueButtonNew
                    id="careers__join_team"
                    href="#current-openings"
                  >
                    Join Our Team
                  </BlueButtonNew>
                </BlueButtonWrapper>
              </GridRight>
            </SectionItemContainer>
          </SectionOne>
        </ContainerDiv>
      </div>
    );
  }
}
